
import collect from 'collect.js'
import Walking from '@/assets/icons/fontawesome/solid/walking.svg?inline'
import BusAlt from '@/assets/icons/fontawesome/light/bus-alt.svg?inline'
import UtensilsAlt from '@/assets/icons/fontawesome/light/utensils-alt.svg?inline'
import MapMarkerAlt from '@/assets/icons/fontawesome/light/map-marker-alt.svg?inline'

export default {
  components: {
    Walking,
    BusAlt,
    UtensilsAlt,
    MapMarkerAlt,
  },
  props: {
    hotel: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    items: null,
  }),
  mounted() {
    this.itemsRequest(0, this.type.split('|'))
  },
  methods: {
    async itemsRequest(i, types) {
      if (i >= types.length) {
        return
      }

      await this.$axios
        .$get('/v3/services/place/nearbysearch', {
          params: {
            location: this.hotel._geoloc.lat + ',' + this.hotel._geoloc.lng,
            radius: 3000,
            type: types[i],
            keyword: types[i],
          },
        })
        .then((response) => {
          if (this.items == null && response.results.length > 0) {
            this.items = collect(response.results)
              .unique('name')
              .slice(0, 8)
              .all()
          } else if (response.results.length > 0) {
            collect(response.results)
              .unique('name')
              .slice(0, 8 - this.items.length)
              .each((item) => this.items.push(item))
          }

          if (this.items != null && this.items.length > 7) {
            return
          }

          this.itemsRequest(i + 1, types)
        })
        .catch(() => {})
    },
    distance(lng2, lat2) {
      const R = 6378137
      const dLat = this.toRad(lat2 - this.hotel._geoloc.lat)
      const dLong = this.toRad(lng2 - this.hotel._geoloc.lng)
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRad(this.hotel._geoloc.lat)) *
          Math.cos(this.toRad(this.hotel._geoloc.lat)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      const distance = R * c

      return distance * 0.001
    },
    getDistance(item) {
      const space = this.distance(
        item.geometry.location.lng,
        item.geometry.location.lat,
      ).toFixed(2)

      return space < 1
        ? this.$i18n.t('{distance} m', { distance: space * 1000 })
        : this.$i18n.t('{distance} km', { distance: space })
    },
    toRad(degrees) {
      return degrees * (Math.PI / 180)
    },
    stepsTime(item) {
      const space = this.distance(
        item.geometry.location.lng,
        item.geometry.location.lat,
      )
      const time = Math.floor((space / 5) * 60)

      if (time >= 20) {
        return null
      }

      return time === 0 ? 1 : time
    },
    driveTime(item) {
      const space = this.distance(
        item.geometry.location.lng,
        item.geometry.location.lat,
      )

      if (Math.floor((space / 5) * 60) < 20) {
        return null
      }

      return Math.floor((space / 60) * 60) === 0
        ? 1
        : Math.floor((space / 60) * 60)
    },
    setMarker(item) {
      this.$emit('setMarker', item)
    },
  },
}
